import { Menu } from 'antd'
import { Title } from 'components'

import { useReactive } from 'ahooks'
import { useMatch } from 'react-router'

export default function(props) {
  const {
      menus
    , params
    , location
    , navigator
  } = props

  const getPath = R.compose(
    R.replace(/\/$/, ''),
  )

  const getCurrentKey = R.compose(
    R.find(str => getPath(location.pathname)?.includes(str)),
    R.map<object, string>(R.prop('key')),
    R.flatten,
    R.concat(R.__, menus),
    R.map<object, object[]>(R.prop('children')),
  )

  const getParentKey = menus => menus.map(R.prop('key')).find((elm: any) => {
    const elms = menus.find(e => e.key == elm)

    if (elms == null) {
      return false
    }

    if(elms.children == null) {
      return false
    }

    else {
      return elms.children.find(e => new RegExp(e.key, 'g').test(getPath(location.pathname)))
    }
  })

  const status = useReactive({
    openKeys: R.of(getParentKey(menus)),
    selectedKeys: R.of(getCurrentKey(menus)),
  })

  return <Menu
    theme='dark'
    mode='inline'
    items={menus}
    openKeys={status.openKeys}
    selectedKeys={status.selectedKeys}
    onClick={e => navigator.to(e.key)}
    onOpenChange={e => Object.assign(status, { openKeys: e })}
  />
}
